import { ModalComponent } from '../../../layout/modals/ModalComponent';
import { Formik } from 'formik';
import React, { Fragment } from 'react';
import * as Yup from 'yup';
import { FormField } from '../../../layout/form-fields/FormField';
import { candidateProfileStore } from '../CandidateProfileStore';

const ValidationSchema = Yup.object().shape({
	fullName: Yup.string().required().label('Full Name'),
	company: Yup.string().required().label('Company'),
	email: Yup.string().required().email().label('Email')
});

export class CandidateProfileHireCandidate extends ModalComponent {
	render() {
		return (
			<Formik
				initialValues={{
					fullName: '',
					company: '',
					email: ''
				}}
				validationSchema={ValidationSchema}
				onSubmit={values => {
					this.saving();
					this.save(values);
				}}>
				{formikBag =>
					this.renderModalContainer(formikBag, 'CandidateProfileHireForm')
				}
			</Formik>
		);
	}

	renderForm(formikBag) {
		return (
			<Fragment>
				<div className="columns">
					<div className="column is-full">
						<FormField
							required
							className="has-text-left"
							label="Full Name"
							field="fullName"
							type="text"
						/>
					</div>
				</div>
				<div className="columns">
					<div className="column is-full">
						<FormField
							required
							className="has-text-left"
							label="Company"
							field="company"
							type="text"
						/>
					</div>
				</div>
				<div className="columns">
					<div className="column is-full">
						<FormField
							required
							className="has-text-left"
							label="Email"
							field="email"
							type="email"
							icon="fa-envelope"
						/>
					</div>
				</div>
			</Fragment>
		);
	}

	async save(values) {
		candidateProfileStore
			.hireCandidate(this.props.PublicLinkId, values)
			.then(result => {
				this.resultNotification(
					result,
					null,
					null,
					'Meet Candidate',
					'Your request to meet this candidate has been sent.'
				);
			});
	}
}
